<div class="main-stage-page-content">
    <div>
        <!-- HERO HEADER ANIMATION WITH COUNTER -->
 
        <app-hero-winner-spot *ngIf="heroType===0"></app-hero-winner-spot>
        <app-country-map-hero *ngIf="heroType===1"></app-country-map-hero>        
        <app-hero-tvc *ngIf="heroType===2"></app-hero-tvc> 
        <app-hero-7-days-countdown *ngIf="heroType===3"></app-hero-7-days-countdown>    
        <app-christmas-hero-spot *ngIf="heroType===4"></app-christmas-hero-spot>
        <app-hero-calender-spot *ngIf="heroType===5"></app-hero-calender-spot>

        <!-- <app-hero-news-spot></app-hero-news-spot> -->
        <!--  <app-millionpakken-hero></app-millionpakken-hero>       --> 
        <!--  <app-usp-hero></app-usp-hero> -->
        <!-- <app-hero-news-spot></app-hero-news-spot> -->
        <!-- <app-home></app-home> -->
    </div>
    <div class="umb-grid w-100 px-0">
        <div class="grid-section">
            <div class="kl-no-color-theme promotion-card-wrapper">
                <div class="container">
                    <div class="row">
                        <div class="card-deck col-m-12">
                            
                          <!-- SPIL MED NU -->
                          <!-- <div class="card m-3 bg-kl-dark text-kl-white">
                            <img (click)="showPage('/lodder-til-salg/lodder')" src="https://klasselotteriet-storage.azureedge.net/files/static/website/forside/promotion-cards/20kr.png" class="card-img-top" alt="Grib chancen for at vinde op til 250.000 kr.">
                            <div class="card-body">
                              <h5 class="card-title">Spil med fra kun 20 kr.</h5>
                              <p class="card-text">For kun 20 kr. om måneden har du chancen for at vinde op til 250.000 kr.</p>
                              <p class="card-text-win-fee">Hver gevinst over 200 kr. fratrækkes gevinstafgift på 15 % inden udbetaling.</p>           
                            </div>
                            <div class="card-footer bg-kl-dark">
                              <a (click)="showPage('/lodder-til-salg/lodder')" class="btn btn-kl btn-kl-blue">Spil med</a>
                            </div>
                          </div>  -->
                         
                         
                         
                         <!--- EKSTERN KONKURRENCE - julekalender 2022 --->
                          <!-- <div class="card m-3 bg-kl-red text-kl-white">
                            <img (click)="onSignUpExternalClick('https://julekalender.klasselotteriet.dk')" src="/assets/images/konkurrencer/julekalender-2022/julekalender-promotioncard.svg" class="card-img-top" alt="Deltag i årets julekalender">
                            <div class="card-body">
                              <h5 class="card-title">Årets julekalender</h5>
                              <p class="card-text">
                                Deltag i vores julekalender hvor der gemmer sig præmier for over 100.000 kr. bag lågerne.
                                <br>For at deltage skal du tilmelde dig Klasselotteriets nyhedsbrev.
                              </p>                   
                            </div>
                            <div class="card-footer bg-kl-red">
                              <a (click)="onSignUpExternalClick('https://julekalender.klasselotteriet.dk')" class="btn btn-kl btn-kl-blue">Deltag her</a>
                            </div>
                          </div> -->

                         
                          <!-- LYKKENUMMER  -->
                          <!-- <div class="card m-3 bg-kl-dark text-kl-white">
                            <img (click)="showPage('/lykkenummer')" src="/assets/images/konkurrencer/lykkenummer/Lykkenummer.svg" class="card-img-top" alt="Deltag nu og se om du er den heldige vinder af 1000 kr.">
                            <div class="card-body">
                              <h5 class="card-title">Lykkenummer-Konkurrence</h5>
                              <p class="card-text">
                                Deltag nu og se om du er den heldige vinder af 1000 kr.
                              </p> 
                              <p class="card-text-win-fee">*For at deltage skal du tilmelde dig Klasselotteriets nyhedsbrev.</p>                  
                            </div>
                            <div class="card-footer bg-kl-dark">
                              <a (click)="showPage('/lykkenummer')" class="btn btn-kl btn-kl-blue">Deltag her</a>
                            </div>
                          </div> -->


                          <!--- EKSTERN KONKURRENCE - vinder-type-2023 (card shown 17-01-2023 till 31-01-2023) --->
                          
                          <div class="card m-3 bg-kl-dark text-kl-white">
                            <img (click)="onSignUpExternalClick('https://get.klasselotteriet.dk/copy-hvilken-lotterivinder-ligner-du')" src="/assets/images/konkurrencer/find-winner-type-2023/promotion-card_anne_341x226.svg" class="card-img-top" alt="HVILKEN VINDERTYPE ER DU?">
                            <div class="card-body">
                              <h5 class="card-title">HVILKEN VINDERTYPE ER DU?</h5>
                              <p class="card-text">
                                Svar på et par spørgsmål og se hvilken vindertype du er – så er du med i konkurrencen om kontanter. Vi finder to personer, der hver vinder 10.000 kr.
                                <br>For at deltage skal du tilmelde dig Klasselotteriets nyhedsbrev.
                              </p>                   
                            </div>
                            <div class="card-footer bg-kl-dark">
                              <a (click)="onSignUpExternalClick('https://get.klasselotteriet.dk/copy-hvilken-lotterivinder-ligner-du')" class="btn btn-kl btn-kl-blue">Deltag her</a>
                            </div>
                          </div>
                          

                          <!-- MILLIONPAKKEN 88%  -->
                          <!-- <div class="card m-3 bg-kl-dark text-kl-white">
                            <img (click)="showPage('/lodder-til-salg/lodpakker')" src="../../../assets/images/forside/promotion-cards/88PCT.png" class="card-img-top" alt="">
                            <div class="card-body">
                              <h5 class="card-title">88% i årlig vinderchance</h5>
                              <p class="card-text">Med Millionpakkens 4 forskellige lodnumre kan du vinde helt op til 1 mio. kr.</p>
                              <p class="card-text">Hver gevinst over 200 kr. fratrækkes gevinstafgift på 15 % inden udbetaling.</p>           
                            </div>
                             <div class="card-footer bg-kl-dark">
                                <a (click)="showPage('/lodder-til-salg/lodpakker')" class="btn btn-kl btn-kl-blue">Køb her</a>
                            </div>  
                          </div>  -->
                         

                          <!-- SÅDAN SPILLER DU MED -->
                          <div class="card m-3 bg-kl-dark text-kl-white">
                            <img (click)="showPage('/glade-vindere')" src="/assets/images/forside/promotion-cards/saadan-spiller-du-med.png" class="card-img-top" alt="">
                            <div class="card-body">
                              <h5 class="card-title">Sådan spiller du med</h5>
                              <p class="card-text">Det er helt enkelt at komme i gang med at spille i Klasselotteriet.</p>
                              <p class="card-text">Hver gevinst over 200 kr. fratrækkes gevinstafgift på 15 % inden udbetaling.</p>
                            </div>
                             <div class="card-footer bg-kl-dark">
                              <a (click)="showPage('/support/om-spillet/hvordan-spiller-jeg-med-i-klasselotteriet')" class="btn btn-kl btn-kl-light">Læs mere</a>
                            </div>  
                          </div>


                          <!--- VINDERHISTORIE-mette --->
                          <!-- --> 
                          <div class="card m-3 bg-kl-dark text-kl-white">
                            <img (click)="showPage('/glade-vindere')" src="/assets/images/forside/promotion-cards/Vinder-Mette-Cards.png" class="card-img-top" alt="">
                            <div class="card-body">
                              <h5 class="card-title">Glade vinderhistorier</h5>
                              <p class="card-text">Mød nogle af vores mange glade vindere. Hvis de kan vinde, så kan du også.</p>
                            </div>
                            <div class="card-footer bg-kl-dark">
                              <a (click)="showPage('glade-vindere')" class="btn btn-kl btn-kl-light mt-3">Læs mere</a>
                            </div> 
                          </div> 


                        <!-- TJEK FOR GEVINST    -->
                        <!-- <div class="card m-3 bg-kl-dark text-kl-white">
                          <img (click)="showPage('/har-jeg-vundet')" src="/assets/images/forside/promotion-cards/Vinder-Kirsten-FP-Cards-transp-bg-txt-kant.png" class="card-img-top" alt="">
                          <div class="card-body">
                            <h5 class="card-title">Tjek om du har vundet</h5>
                            <p class="card-text">Se om dit lodnummer er udtrukket i månedens trækning.</p>
                          </div>
                          <div class="card-footer bg-kl-dark">
                            <a (click)="showPage('har-jeg-vundet')" class="btn btn-kl btn-kl-light mt-3">Tjek for gevinst</a>
                          </div> 
                        </div> -->

                        <!-- UDLODNINGSMIDLER -->
                        <!--
                        <div class="card m-3 bg-kl-red text-kl-white">
                          <img (click)="showPage('/support/mest-stillede-sporgsmal/hvad-gar-lotteriets-overskud-til')" src="../../../assets/images/support/Udlodningsmidler_100mio_card_cropped.png" class="card-img-top" alt="">
                          <div class="card-body">
                            <h5 class="card-title">Klasselotteriet bidrager til udlodningsmidlerne</h5>
                            <p class="card-text">Når du spiller med i Klasselotteriet, er du med til at støtte en lang række almennyttige formål.</p>
                          </div>
                          <div class="card-footer bg-kl-red">
                            <a (click)="showPage('/support/mest-stillede-sporgsmal/hvad-gar-lotteriets-overskud-til')" class="btn btn-kl btn-kl-light mt-3">Læs mere</a>
                          </div> 
                        </div>
                        -->



                        <!-- Presse-besked-vinder -->
                        <!--
                        <div class="card m-3 bg-kl-red text-kl-white">
                          <img (click)="showPage('/om-klasselotteriet/selskabet/pressemeddelelser/vindermeddelelse')" src="/assets/images/forside/promotion-cards/pressemeddelelser-card.png" class="card-img-top" alt="">
                          <div class="card-body">
                            <h5 class="card-title">Klimavenlig sønderjyde vinder 1,7 millioner i Klasselotteriet</h5>
                            <p class="card-text">En ældre mand fra Sønderjylland har spillet med i Klasselotteriet i flere år og blev endelig ramt af heldet. Nu skal børnene forkæles, og pengene skal investeres.</p>
                          </div>
                          <div class="card-footer bg-kl-red">
                            <a (click)="showPage('/om-klasselotteriet/selskabet/pressemeddelelser/vindermeddelelse')" class="btn btn-kl btn-kl-light mt-3">Læs historien</a>
                          </div> 
                        </div>
                        -->
                        </div>
                    </div>
                  </div>
            </div>
            <div class="kl-light">
                <div class="container">
                    <div class="row clearfix">
                        <div class="col-md-12">
                            <div>
                                <div class="content-block current-competition pb-5">
                                    <div *ngIf="allCompetitions">
                                        <div *ngFor="let competition of allCompetitions; let index=index; let odd=odd; let even=even;">
                                            <div class="col-12 mb-4 mt-4">
                                                <div class="col-12 competition" [ngClass]="{ odd: odd, even: even }">
                                                    <div class="row">
                                                        <div class="col-md-12 col-lg-6 no-padding overflow-hidden competition-img-wrapper"
                                                            [ngClass]="{ 'order-first order-lg-last': odd}">
                                                            <div class="competition-current-img" style="background-image: url(../../../assets/images/konkurrencer/35350_klasselotteriet_AktuelKonkurrence_1920x1080.png)">
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12 col-lg-6 competition-description"
                                                            [ngClass]="{ 'order-last order-lg-first': odd}">
                                                            <ng-container *ngIf="competition.ExternalCompetitionUrl">
                                                                <h1 (click)="onSignUpExternalClick(competition.ExternalCompetitionUrl)">
                                                                    {{ competition.Title }}</h1>
                                                            </ng-container>
                                                            <ng-container *ngIf="!competition.ExternalCompetitionUrl">
                                                                <h1 (click)="showPage('/aktuelle-konkurrencer/tilmelding?competitionid=' + competition.Id)">{{ competition.Title }}</h1>
                                                            </ng-container>
                                                            <p [innerHtml]="competition.DescriptionPrize"></p>
                                                            <ng-container *ngIf="competition.ExternalCompetitionUrl">
                                                                <p class="competition-link mt-0 mt-xl-4"><a
                                                                    (click)="onSignUpExternalClick(competition.ExternalCompetitionUrl)">
                                                                    DELTAG HER</a></p>
                                                            </ng-container>
                                                            <ng-container *ngIf="!competition.ExternalCompetitionUrl">
                                                                <p class="competition-link mt-0 mt-xl-4"><a
                                                                    (click)="showPage('/aktuelle-konkurrencer/tilmelding?competitionid=' + competition.Id)">Deltag
                                                                    her</a></p>
                                                            </ng-container>
                    
                                                            <p class="valid-date"><small>Konkurrencen løber til og med
                                                                    {{ competition.ActiveTo | date: 'd'}}. {{ competition.ActiveTo | date: 'MMMM yyyy'}}</small></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <app-accordion></app-accordion>
            </div>

            <div class="kl-no-color-theme">
                <div class="container">
                    <div class="row clearfix">
                        <div class="col-md-12">
                            <div>
                                <div class="ticket-carousel">
                                    <h2>
                                        VIDSTE DU AT:
                                    </h2>
                                    <div *ngIf="!hovered1_4 && !hovered1_2 && !hovered1_1 && !hovered3_2" class="ticket-carousel-summary col-10 offset-1 col-sm-12 offset-sm-0">I
                                        Klasselotteriet kan du få chancen for at vinde op til 250.000 kr.* fra kun 20 kr.
                                        om måneden</div>
                                    <div *ngIf="hovered1_4" class="ticket-carousel-summary col-10 offset-1 col-sm-12 offset-sm-0">I
                                        Klasselotteriet kan du få chancen for at vinde op til 500.000 kr.* fra kun 40 kr.
                                        om måneden</div>
                                    <div *ngIf="hovered1_2" class="ticket-carousel-summary col-10 offset-1 col-sm-12 offset-sm-0">I
                                        Klasselotteriet kan du få chancen for at vinde op til 1.000.000 kr.* fra kun 80 kr.
                                        om måneden</div>
                                    <div *ngIf="hovered1_1" class="ticket-carousel-summary col-10 offset-1 col-sm-12 offset-sm-0">I
                                        Klasselotteriet kan du få chancen for at vinde op til 2.000.000 kr.* fra kun 160 kr.
                                        om måneden</div>
                                    <div *ngIf="hovered3_2" class="ticket-carousel-summary col-10 offset-1 col-sm-12 offset-sm-0">I
                                        Klasselotteriet kan du få chancen for at vinde op til 3.000.000 kr.* fra kun 240 kr.
                                        om måneden</div>

                                    <div class="ticket-carousel-win-note col-10 offset-1 col-sm-12 offset-sm-0">
                                        *Hver gevinst over 200 kr. fratrækkes gevinstafgift på 15 %</div>

                                    <ul class="ticket-carousel-list">
                                        <li class="ticket-carousel-list-item ticket-carousel-list-item-3_2" (mouseover)="hovered3_2=true" (mouseout)="hovered3_2=false" [ngClass]="{'active': hovered3_2===true}"
                                            (click)="showPage('/lodder-til-salg/lodder?lod=mega&ticketinfo=1')"
                                            data-ticket-id="3_2" ><img
                                                src="../../../assets/images/tickets/outlined-fractions/MEGALOD-Outlined.svg"></li>
                                        <li class="ticket-carousel-list-item ticket-carousel-list-item-1_1" (mouseover)="hovered1_1=true" (mouseout)="hovered1_1=false" [ngClass]="{'active': hovered1_1===true}"
                                            (click)="showPage('/lodder-til-salg/lodder?lod=hel&ticketinfo=1')"
                                            data-ticket-id="1_1"><img
                                                src="../../../assets/images/tickets/outlined-fractions/HELLOD-Outlined.svg"></li>
                                        <li class="ticket-carousel-list-item ticket-carousel-list-item-1_2" (mouseover)="hovered1_2=true" (mouseout)="hovered1_2=false" [ngClass]="{'active': hovered1_2===true}"
                                            (click)="showPage('/lodder-til-salg/lodder?lod=halv&ticketinfo=1')"
                                            data-ticket-id="1_2"><img
                                                src="../../../assets/images/tickets/outlined-fractions/HALVLOD-Outlined.svg"></li>
                                        <li class="ticket-carousel-list-item ticket-carousel-list-item-1_4" (mouseover)="hovered1_4=true" (mouseout)="hovered1_4=false" [ngClass]="{'active': hovered1_4===true}"
                                            (click)="showPage('/lodder-til-salg/lodder?lod=kvart&ticketinfo=1')"
                                            data-ticket-id="1_4"><img
                                                src="../../../assets/images/tickets/outlined-fractions/KVARTLOD-Outlined.svg"></li>
                                        <li class="ticket-carousel-list-item ticket-carousel-list-item-1_8" (mouseover)="hovered1_8=true" (mouseout)="hovered1_8=false" [ngClass]="{'active': hovered1_4===false && hovered1_2===false && hovered1_1===false && hovered3_2===false}"
                                            (click)="showPage('/lodder-til-salg/lodder?lod=ottendedel&ticketinfo=1')"
                                            data-ticket-id="1_8"><img
                                                src="../../../assets/images/tickets/outlined-fractions/1-8-LOD-Outlined.svg"></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
